// 05 · Head-cock — the driver shared by every host of the shot.
//
// The shot is IN → LOOP(×n) → OUT (brief §5). Nothing here knows how long a
// request takes; callers start it and stop it, and the loop covers whatever
// happens in between. Keyframes live in otto.css.
//
// One driver, not one per host: the gallery demo and the real loading scene
// both run this, so the demo exercises the shipping path instead of a
// look-alike with its own timings that can drift out of sync.

export const COCK = { in: 450, loop: 1800, out: 450 };

// Below this, playing intro-then-outro is a flinch — better to show nothing
// (brief §5). Hosts should also gate their own bar on it.
export const COCK_FLOOR_MS = 600;

const CLASSES = ['otto-cock-in', 'otto-cock-loop', 'otto-cock-out'];

// Pupil travel cap. Past ~2.2px the pupil clips the iris and reads as a
// squint rather than a look, so the whole gaze vector is scaled to fit.
const GAZE_MAX = 1.8;

// Current rotation of a running animation, in degrees, straight out of the
// computed matrix. This is what lets the outro start from where the head
// ACTUALLY is at cut time rather than from a canned keyframe — a response
// landing mid-swing must not snap the head somewhere else before unwinding.
export function currentAngle(el) {
  if (!el || typeof getComputedStyle === 'undefined') return 0;
  const t = getComputedStyle(el).transform;
  if (!t || t === 'none') return 0;
  const m = t.match(/matrix\(([^)]+)\)/);
  if (!m) return 0;
  const [a, b] = m[1].split(',').map(parseFloat);
  if (!isFinite(a) || !isFinite(b)) return 0;
  return (Math.atan2(b, a) * 180) / Math.PI;
}

// Where is the bar relative to his eyes? Direction is computed, never baked:
// he can legitimately sit on either side of the indicator (brief §8.3), and a
// hardcoded up-and-right offset would have him staring into space on a
// right-aligned layout.
//
// Otto's eyes sit at viewBox y66 of 132 — dead centre of his box — so the
// owl element's own centre is the eye point.
export function gazeVector(owlEl, barEl) {
  const fallback = { x: GAZE_MAX * 0.9, y: -GAZE_MAX * 0.9 };
  if (!owlEl || !barEl) return fallback;
  const o = owlEl.getBoundingClientRect();
  const b = barEl.getBoundingClientRect();
  if (!o.width || !b.width) return fallback;
  const dx = (b.left + b.width / 2) - (o.left + o.width / 2);
  const dy = (b.top + b.height / 2) - (o.top + o.height / 2);
  const len = Math.hypot(dx, dy);
  if (!len) return fallback;
  return { x: (dx / len) * GAZE_MAX, y: (dy / len) * GAZE_MAX };
}

function clearPhases(el) {
  CLASSES.forEach((c) => el.classList.remove(c));
}

// Starts IN, hands over to LOOP, and returns stop() — which reads the live
// angle, plays OUT from there, and resolves when the head is level again.
// stop() is safe to call at any point, including before IN has finished.
export function playHeadCock(wrapEl, { barEl = null } = {}) {
  if (!wrapEl) return () => Promise.resolve();

  const gaze = gazeVector(wrapEl, barEl);
  wrapEl.style.setProperty('--otto-gaze-x', `${gaze.x.toFixed(2)}px`);
  wrapEl.style.setProperty('--otto-gaze-y', `${gaze.y.toFixed(2)}px`);

  clearPhases(wrapEl);
  void wrapEl.offsetWidth;                 // restart cleanly on a repeat fire
  wrapEl.classList.add('otto-cock-in');

  let stopped = false;
  const toLoop = setTimeout(() => {
    if (stopped) return;
    // Swapped in ONE mutation so the browser never lays out a frame with
    // neither class applied, which would flash the head back to level.
    wrapEl.classList.remove('otto-cock-in');
    wrapEl.classList.add('otto-cock-loop');
  }, COCK.in);

  return function stop() {
    if (stopped) return Promise.resolve();
    stopped = true;
    clearTimeout(toLoop);

    const from = currentAngle(wrapEl);
    wrapEl.style.setProperty('--otto-cock-from', `${from.toFixed(2)}deg`);
    // Counter-swing opposes wherever he is, so the unwind reads as a settle
    // from either side instead of a snap. Level heads get the default sign.
    const back = (from > 0 ? -4 : 4);
    wrapEl.style.setProperty('--otto-cock-back', `${back}deg`);

    clearPhases(wrapEl);
    wrapEl.classList.add('otto-cock-out');

    return new Promise((resolve) => {
      setTimeout(() => {
        clearPhases(wrapEl);
        wrapEl.style.removeProperty('--otto-cock-from');
        wrapEl.style.removeProperty('--otto-cock-back');
        wrapEl.style.removeProperty('--otto-gaze-x');
        wrapEl.style.removeProperty('--otto-gaze-y');
        resolve();
      }, COCK.out);
    });
  };
}
